"use strict";Object.defineProperty(exports, "__esModule", {value: true});

 const superUserOrgKeys = {
  '1b9e5234-cca7-4e5f-a333-a229a8c544cb': true, // BloomText (dev)
  '943a2605-102f-4c18-af86-e9bb0126f098': true, // BloomText (prod)
  '08a577ff-b213-4b6e-b524-e56e78fb1069': true, // Narnia Associates (dev)
} ; exports.superUserOrgKeys = superUserOrgKeys
